import { type FC, useCallback, useEffect, useState } from 'react';
import useMeetingCoHosts from '../../hooks/useMeetingCoHosts';
import type { CoHostsSectionProps } from '../../types';
import CoHostAddForm from './CoHostAddForm';
import CoHostList from './CoHostList';
import CoHostToggle from './CoHostToggle';

const CoHostsSection: FC<CoHostsSectionProps> = ({
  selectedMeetingData,
  isUpdating,
  updateMeetingData,
}) => {
  const { coHostEmails } = selectedMeetingData;
  const [isEnabled, setIsEnabled] = useState(coHostEmails.length > 0);

  const { updateCoHosts, removeCoHost, addCoHost } = useMeetingCoHosts({
    meetingData: selectedMeetingData,
    onUpdate: updateMeetingData,
  });

  useEffect(() => {
    setIsEnabled(coHostEmails.length > 0);
  }, [coHostEmails.length]);

  const handleToggle = useCallback(
    (enabled: boolean) => {
      setIsEnabled(enabled);
      if (!enabled && coHostEmails.length > 0) {
        updateCoHosts([]);
      }
    },
    [updateCoHosts, coHostEmails],
  );

  return (
    <div className="personal-meetings-modal__cohost-section">
      <CoHostToggle enabled={isEnabled} disabled={isUpdating} onChange={handleToggle} />

      {isEnabled && (
        <>
          <CoHostList coHosts={coHostEmails} disabled={isUpdating} onRemove={removeCoHost} />
          <CoHostAddForm disabled={isUpdating} onAdd={addCoHost} />
        </>
      )}
    </div>
  );
};

export default CoHostsSection;
